/**
 * Support desk permission keys.
 *
 * <p>Three, not more. The repo measures ~39 bytes per action claim against a staging admin
 * token already near 4,874 bytes with an 8 KB ingress buffer — every key is real weight on
 * every request, so the one-thread-per-agent rule stays role logic rather than becoming a
 * fourth key.</p>
 *
 * <p>⚠️ These must be SEEDED BY api.core BEFORE any UI gates on them, and users must
 * re-login: TokenService stamps `action` claims at mint time, so an existing session never
 * gains a newly created key. Until that lands, the menu entry uses a borrowed gate — see
 * `data.tsx`.</p>
 */
export const ACTIONS_SUPPORT = {
	SUPPORT_DESK: 'support_desk',
	SUPPORT_DESK_SEND: 'support_desk_send',
	SUPPORT_DESK_MODERATE: 'support_desk_moderate',
} as const;
